<div class="grid-margin stretch-card macro-card" (click)="increase()">
    <div class="card macro">
        <span id="water-target-max">{{ fixedNumber(this.userWater.water_target) }}L</span>
        <span id="water-target">{{ fixedNumber(this.userWater.min_water_target) }}L</span>

        <div class="card-body no-padding"
             [ngStyle]="{'background': 'linear-gradient(90deg, rgb(219, 240, 255) '+percentage(this.userWater.consumed, this.userWater.water_target)+', #fff 0%)'}">
            <div class="col-2 no-padding text-align-center d-flex flex-column justify-content-center">
                <img
                        class="macro-image flipInX animated"
                        src="assets/images/macros/water.svg"
                        alt="{{ 'water' | localise }}"/>
            </div>
            <div class="col-10 no-padding d-flex flex-column justify-content-center macro-title">
                {{ 'water' | localise }}
            </div>
        </div>
    </div>
</div>
